//layaout
export const FooterText = "UNEPP ";
export const Back = "Regresar";
export const logout = "Log out";
export const Sidebarmenutext = "Forma parte de una nueva argentina";
export const Configuration = "Configuracion";
export const CopyText = "Copy rigth 2024";
// Users
export const Users = "Usuarios";

// titles

export const Entities = "Entidades";
export const ContatcCharges = "Cargos de contactos";
// Contacts
export const PersonalDataTitle = "Datos personales";
export const ContactHistory = "Contact History";
export const ContactCreated = "Contact Created";
export const NewContacts = " New Contacts";
export const AddContacts = "Agregar Contacto";
export const Contacts = "Contactos";

//Errors
export const successDeleted = "Registro eliminado!";
export const genericError = "Ha ocurrido un error:";
export const errorGettingData = "Error obteniendo datos";
export const errorDeleteingData = "Error eliminado datos";
export const errorInvalidaDate = "La fecha no es válida";
export const errorUpdatingData = "Error actualizando datos";
export const errorInsertingData = "Error insertando datos";

//General
export const Cancel = "Cancelar";
export const Selectdefault = "Selecciona";
export const ItemUpdated = "Registro actualizado";
export const ItemCreated = "Registro creado";
export const ItemDeleted = "Registro eliminado";

//FIELDS

export const EmailAddress = "Correo electronico";
export const Password = "Contraseña";
export const Save = "Guardar";
export const EmailPassword = "Con tu correo y contraseña";
export const orSigninwith = "O autenticate con";
export const Donthaveaccount = "No tienes una cuenta?";
export const CreateAccount = "Crear cuenta";
export const RememberPassword = "Recordar contraseña";

export const signinaccount = "Inicia session";
